"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LISTING_FEEDBACK_BUYER_UPDATE_EMAIL_UTM_CAMPAIGN = void 0;
/**
 * UTM campaign identifier for listing feedback buyer update emails
 */
exports.LISTING_FEEDBACK_BUYER_UPDATE_EMAIL_UTM_CAMPAIGN = 'listing-feedback-buyer-update-email';
